import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'vietnam_does_the_fac_collect_and_forward_wrkrs_contributions_as'

export const dataPointDefinition = {
  retracedId: 'vietnam_does_the_fac_collect_and_forward_wrkrs_contributions_as',
  name: "Vietnam: Does the facility collect and forward workers' contributions as legally required and pay the legally required employer contributions to social, health and unemployment insurance funds on time?",
  description:
    'This question is specific to Vietnam only and applies when either one of these previous questions is selected with "X":\r\r\nNot applicable - worker and facility contributions cannot be separated and/ or broken down\r\r\nNot applicable - worker and facility contributions cannot be separated and/ or broken down\r\r\n\r\r\nPlease consult the Law Overlay for more information on applicable legal requirements. ',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wag-111',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 9230,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
